const initialState = {
    status: false
}
export const ACTIONS: any = { BADGE_STATUS: "BADGE_STATUS" }

export default function StatusBadgeReducer(state = initialState, action: any):{status:boolean} {
    switch (action.type) {
        case ACTIONS.BADGE_STATUS:
            return {
                status: action.status,
            }
        default:
            return state;
    }
}